import { useEffect, useState } from "react"

const useHasScrolled = () => {
    const [hasScrolled, setHasScrolled] = useState(false)

    useEffect(() => {
        const handleWindowScroll = () => {
            setHasScrolled(document.documentElement.scrollTop > 0)
        }
        handleWindowScroll()
        window.addEventListener("scroll", handleWindowScroll)
        return () => {
            window.removeEventListener("scroll", handleWindowScroll)
        }
    }, [])

    return hasScrolled
}

export { useHasScrolled }
